import { ECommonRequestStatusesForAssetRequest } from '@enums/asset';

const {
	allApproved,
	allDisapproved,
	partlyApproved,
	pending,
	inProgress,
	declined,
	cancelled,
	updated,
	sentForAcceptance,
	sentForRevision,
	accepted,
	done,
	contract,
	ended,
} = ECommonRequestStatusesForAssetRequest;

export const requestApprovingSteps = (activeStatus: string) => {
	const isCanceledOrDeclined = activeStatus === cancelled || activeStatus === declined;
	const isCanceledOrDeclinedOrDone = isCanceledOrDeclined || activeStatus === done || activeStatus === ended;

	const steps = [
		{
			title: 'Pending',
			value: pending,
			isActive: activeStatus === pending,
			isHidden: isCanceledOrDeclinedOrDone,
		},
		{
			title: 'Updated',
			value: updated,
			isActive: activeStatus === updated,
			isHidden: isCanceledOrDeclinedOrDone || activeStatus !== updated,
		},
		{
			title: 'In progress',
			value: inProgress,
			isActive: activeStatus === inProgress,
			isHidden: isCanceledOrDeclinedOrDone,
		},
		{
			title: 'Partly approved',
			value: partlyApproved,
			isActive: activeStatus === partlyApproved,
			isHidden: isCanceledOrDeclinedOrDone || (
				activeStatus !== partlyApproved
				&& (activeStatus === allDisapproved || activeStatus === allApproved)
			),
		},
		{
			title: 'All disapproved',
			value: allDisapproved,
			isActive: activeStatus === allDisapproved,
			isHidden: isCanceledOrDeclinedOrDone || (
				activeStatus !== allDisapproved
				&& (activeStatus === partlyApproved || activeStatus === allApproved)
			),
		},
		{
			title: 'Sent for Acceptance',
			value: sentForAcceptance,
			isActive: activeStatus === sentForAcceptance,
			isHidden: isCanceledOrDeclinedOrDone || (
				activeStatus !== sentForAcceptance
			),
		},
		{
			title: 'Sent for Revision',
			value: sentForAcceptance,
			isActive: activeStatus === sentForRevision,
			isHidden: isCanceledOrDeclinedOrDone || (
				activeStatus !== sentForRevision
			),
		},
		{
			title: 'All approved',
			value: allApproved,
			isActive: activeStatus === allApproved,
			isHidden: isCanceledOrDeclinedOrDone || (
				activeStatus !== allApproved
				&& (activeStatus === partlyApproved || activeStatus === allDisapproved)
			),
		},
		{
			title: 'Accepted',
			value: accepted,
			isActive: activeStatus === accepted,
			isHidden: isCanceledOrDeclinedOrDone,
		},
		{
			title: 'Contract',
			value: contract,
			isActive: activeStatus === contract,
			isHidden: isCanceledOrDeclinedOrDone,
		},
		{
			title: 'Done',
			value: done,
			isActive: activeStatus === done,
			isHidden: isCanceledOrDeclined || activeStatus === ended,
		},
		{
			title: 'Ended',
			value: ended,
			isActive: activeStatus === ended,
			isHidden: activeStatus !== ended,
		},
		{
			title: 'Declined',
			value: declined,
			isActive: activeStatus === declined,
			isHidden: activeStatus !== declined,
		},
		{
			title: 'Cancelled',
			value: cancelled,
			isActive: activeStatus === cancelled,
			isHidden: activeStatus !== cancelled,
		},
	];

	return steps
		.filter(item => {
			if (item.isActive) return true;

			if (
				(activeStatus !== allApproved && activeStatus !== allDisapproved && activeStatus !== partlyApproved)
				&& (item.value === allApproved || item.value === allDisapproved || item.value === partlyApproved)
			) {
				return item.value === allApproved && !isCanceledOrDeclinedOrDone;
			}

			if (
				(activeStatus === allApproved || activeStatus === allDisapproved || activeStatus === partlyApproved)
				&& (item.value === allApproved || item.value === allDisapproved || item.value === partlyApproved)
			) {
				return activeStatus === item.value;
			}

			return !item.isHidden;
		});
};

export const actionButtons = ({
	activeStatus,
	isAssetOwner,
	actions,
	accessPermission,
}: {
	activeStatus: string;
	isAssetOwner: boolean;
	accessPermission?: any;
	actions: {
		sendToMNOHandler: () => void;
		sendToAOHandler: () => void;
		acceptHandler: () => void;
		contractHandler?: () => void;
		doneHandler?: () => void;
	};
}) => {
	const {
		sendToMNOHandler,
		acceptHandler,
		sendToAOHandler,
		contractHandler,
		doneHandler,
	} = actions;

	const buttons = [
		{
			title: 'Accept',
			onClick: () => acceptHandler && acceptHandler(),
			isShowed: isAssetOwner
				? activeStatus === allApproved && accessPermission.assetOwnerManageRequests
				: activeStatus === sentForAcceptance,
		},
		{
			title: 'Send for acceptance',
			onClick: () => sendToMNOHandler && sendToMNOHandler(),
			isShowed: isAssetOwner
				&& (activeStatus === sentForRevision || activeStatus == partlyApproved)
				&& accessPermission.assetOwnerManageRequests,
		},
		{
			title: 'Send back for revision',
			onClick: () => sendToAOHandler && sendToAOHandler(),
			isShowed: !isAssetOwner && activeStatus === sentForAcceptance
				&& (accessPermission.networkOperatorAssetEnquirer || accessPermission.assetConsumerAssetEnquirer),
		},
		{
			title: 'Contract',
			onClick: () => contractHandler && contractHandler(),
			isShowed: isAssetOwner && activeStatus === accepted && accessPermission.assetOwnerSignatory,
		},
		{
			title: 'Done',
			onClick: () => doneHandler && doneHandler(),
			isDisabled: activeStatus !== contract,
			disabledDescription: 'Accept button',
			isShowed: isAssetOwner && activeStatus === contract && accessPermission.assetOwnerSignatory,
		},
	];

	return buttons.filter(item => item.isShowed);
};
